import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useOpsAuth } from '@/ops/OpsAuthContext';
import { LayoutDashboard, Users, Activity, LogOut, BarChart3, Server } from 'lucide-react';
import '@/ops/ops-theme.css';

const NAV = [
  { to: '/ops/dashboard', icon: LayoutDashboard, label: 'Dashboard', tid: 'nav-dashboard-link' },
  { to: '/ops/analytics', icon: BarChart3, label: 'Analytics', tid: 'nav-analytics-link' },
  { to: '/ops/users', icon: Users, label: 'Users', tid: 'nav-users-link' },
  { to: '/ops/system', icon: Server, label: 'System', tid: 'nav-system-link' },
  { to: '/ops/logs', icon: Activity, label: 'Audit Log', tid: 'nav-logs-link' },
];

export default function OpsShell() {
  const { opsUser, logout } = useOpsAuth();
  const navigate = useNavigate();

  const handleLogout = async () => { await logout(); navigate('/ops/login'); };

  return (
    <div className="ops-root flex h-screen overflow-hidden">
      {/* Sidebar */}
      <aside className="w-60 shrink-0 flex flex-col" style={{ borderRight: '1px solid var(--ops-border)' }}>
        {/* Brand */}
        <div className="px-5 h-16 flex items-center" style={{ borderBottom: '1px solid var(--ops-border)' }}>
          <div className="leading-none">
            <span style={{ fontFamily: "'Instrument Serif', Georgia, serif", fontSize: 22, color: 'var(--ops-text)' }}>Milk</span>
            <span className="ops-mono" style={{ fontSize: 13, color: 'var(--ops-muted)', marginLeft: 4 }}>/ops</span>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-4 space-y-1">
          <p className="ops-overline px-3 pb-2">Operations</p>
          {NAV.map(({ to, icon: Icon, label, tid }) => (
            <NavLink key={to} to={to} data-testid={tid}
              className={({ isActive }) => `ops-nav ${isActive ? 'ops-nav-active' : ''}`}>
              <Icon size={15} />{label}
            </NavLink>
          ))}
        </nav>

        {/* Footer / identity */}
        <div className="px-3 py-3" style={{ borderTop: '1px solid var(--ops-border)' }}>
          <div className="ops-card px-3 py-2.5 mb-2 flex items-center justify-between" style={{ background: 'var(--ops-surface-2)' }}>
            <div className="min-w-0">
              <p className="text-xs font-medium truncate" style={{ color: 'var(--ops-text)' }}>{opsUser?.name}</p>
              <p className="ops-mono text-[10px] truncate" style={{ color: 'var(--ops-muted)' }}>{opsUser?.email}</p>
            </div>
            <span className="ops-badge ops-badge-info">{opsUser?.role?.replace('_', ' ')}</span>
          </div>
          <button onClick={handleLogout} data-testid="ops-logout-button"
            className="ops-nav w-full" style={{ color: '#F87171' }}>
            <LogOut size={14} />Sign out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-y-auto">
        <div className="max-w-[1280px] mx-auto px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
